import dayjs from 'dayjs';

export const getIsoStringFromDate = (date: Date | number): string =>
  dayjs(date).startOf('day').utc(true).toISOString();
